import { render, staticRenderFns } from "./WettkampfUebersicht.vue?vue&type=template&id=24144767&"
import script from "./WettkampfUebersicht.vue?vue&type=script&lang=js&"
export * from "./WettkampfUebersicht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports